import { toPackageName } from '@atlassian/jira-project-settings-apps-common/src/consts.tsx';
import type { PackageName } from '@atlassian/jira-project-settings-apps-common/src/types.tsx';
import type { PropertiesKey } from './types.tsx';

export const PACKAGE_NAME: PackageName = toPackageName(
	'jiraProjectSettingsAppsIssueTypePageJsmCommon',
);

export const TEAM_NAME = 'jsd-shield';

export const ASSOCIATED_SCREEN_ID_REQUEST_OWNER_PROPERTY_KEY =
	'jsm.issue.type.associated.screen.id';

/// FFC M2
export const FFC_M2_SPOTLIGHT_ID = 'ffc-m2-changeboarding-spotlight';
export const FFC_M2_SPOTLIGHT_TARGET_ID = 'ffc-m2-changeboarding-spotlight-target';
export const FFC_M2_DOCUMENTATION_LINK =
	'https://support.atlassian.com/jira-service-management-cloud/docs/customize-the-fields-of-a-request-type/';
export const FFC_M2_SPOTLIGHT_USER_PROPERTY_KEY =
	'jsm-ffc-m2-changeboarding-notification-flag-seen-status';
export const FFC_M2_SPOLIGHT_SCREEN_NAME = 'jsmFfcM2ChangeboardingSpotlight';

// in-product help article ID for request type configuration
export const PRODUCT_HELP_ARTICLE_ID = '6I42ggwGORmP84atFaD3hS';
export const PRODUCT_HELP_LINK =
	'https://support.atlassian.com/jira-cloud-administration/docs/configure-a-custom-field/#Troubleshoot-issue-configuration-and-context';
export const ARTICLE_ID = '6xVM2KuVxM8FhqDJ9Wdpii';
// Text that we get is already translated at this point and we're interested in the pure string only, so we only add this random id to comply with the API
// and to make sure no real translation will be put under this fake key
export const PRODUCT_HELP_IPH_LINK_ID = 'c29tZSBoYXNoIGZvciByZWFjdC1pbnRsIGtleQ==.no-translate';

// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum LayoutType {
	RequestForm = 'REQUEST_FORM',
	IssueView = 'ISSUE_VIEW',
}

export const LayoutTypeUser = {
	Customer: 'customer',
	Agent: 'agent',
};

export const JSD_FIELD_ALIAS: PropertiesKey = 'jsd.field.displayName';
export const JSD_FIELD_HELPTEXT: PropertiesKey = 'jsd.field.helpText';
export const JSD_FIELD_APPROVAL_CONFIG: PropertiesKey = 'jsd.field.approval.config';
export const JSD_FIELD_APPROVAL_ALL_CONFIGS: PropertiesKey = 'jsd.field.approval.all.configs';

export const FVH_CHANGEBOARDING_TOUR_USER_PROPERTY_KEY = 'jsm-fvh-changeboarding-tour-seen-status';
export const FVH_CHANGEBOARDING_ANALYTICS_SOURCE_NAME = 'jsmFvhChangeboardingTour';
export const FVH_CHANGEBOARDING_SPOTLIGHT_TARGETS = {
	SIDEBAR: 'jsm-fvh-changeboarding-tour-spotlight-target-sidebar',
	MAIN_AREA: 'jsm-fvh-changeboarding-tour-spotlight-target-main-area',
} as const;
export const FVH_ANALYTICS_SPOTLIGHT_IDS = {
	INTRO_SPOTLIGHT: 'introSpotlight',
	SIDEBAR_SPOTLIGHT: 'sidebarSpotlight',
	MAIN_AREA_SPOTLIGHT: 'mainAreaSpotlight',
} as const;

export const REQUEST_FORM_LOZENGE_COMPONENT_ID = 'request-form-sidebar-lozenge';
export const ISSUE_VIEW_LOZENGE_COMPONENT_ID = 'issue-view-sidebar-lozenge';
